import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { DropDownMenuProps } from '../../models/dropDownMenu.interface';

export const DropDownMenu = ({anchorEl, setAnchorEl, dropDownItems}: DropDownMenuProps) => {
  return <>
    <Menu
      keepMounted
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      style={{zIndex: 1500}}
      open={Boolean(anchorEl)}
      onClose={() => {
        setAnchorEl(null);
      }}
    >
      {dropDownItems.map(dropDownItem =>
        <MenuItem
          key={dropDownItem.key}
          onClick={dropDownItem.onClick}
        >
          {dropDownItem.children}
        </MenuItem>
      )}
    </Menu>
  </>;
};